
import { FETCH_SYNTHESE_ANNEE_REQUEST, FETCH_SYNTHESE_ANNEE_SUCCESS, FETCH_SYNTHESE_ANNEE_FAILURE } from './actionsTypes';

export const fetchSyntheseAnneeRequest = (token,history) => ({
  type: FETCH_SYNTHESE_ANNEE_REQUEST,
  payload: { token,history },
});

export const fetchSyntheseAnneeSuccess = (syntheseAnneeData) => ({
  type: FETCH_SYNTHESE_ANNEE_SUCCESS,
  payload: { syntheseAnneeData },
});

export const fetchSyntheseAnneeFailure = (error) => ({
  type: FETCH_SYNTHESE_ANNEE_FAILURE,
  payload: { error },
});

